import { Injectable } from '@angular/core';

import { CodeValue } from '../models/code-value';

export const NAMESPACE_A2C_FIELD = 'eoffer-prd-fn.';
export const NAMESPACE_RTPC_FIELD = 'eoffer-prd-fn_rtpc.';

@Injectable({ providedIn: 'root' })
export class ProductCharacteristicsTranslationService {
	private readonly dico = new Map<string, string>();

	addEntry(key: string, value: string) {
		this.dico.set(key, value);
	}

	add(dicoPart: CodeValue[] | undefined) {
		if (!dicoPart) {
			return;
		}
		for (const entry of dicoPart) {
			this.dico.set(entry.code, entry.value);
		}
	}

	clear() {
		this.dico.clear();
	}

	translate(code: string) {
		return this.dico.get(code) || code;
	}
}
